<div class="row mt-1 mb-2">
    <div class="col pb-1" style="overflow:auto;" [ngStyle]="{'max-height': maxHeight + 'px'}">
        <h6 class="mb-3">Tag disponibles</h6>
        <ul (dndDrop)="onDrop($event,1)" class="list-group rounded-1 shadow-sm" dndDropzone>
            <li *ngFor="let item of tagsAvailable" (dndStart)="onDragStart($event,1)" [dndDraggable]="item"
                class="list-group-item border rounded-1 bg-white">
                <span><b><i class="fa-solid fa-tag me-1"></i>{{ item?.tag | uppercase }} </b></span>
                <small>({{ item?.code }})</small>
                <br>
                <span class="text-primary"><i class="fa-solid fa-map-location-dot"></i></span><span> {{item?.location || "Sin especificar"}}</span>
                
            </li>
            <li *ngIf="tagsAvailable?.length==0">
                <small class="text-warning">
                    Sin tag disponibles
                </small>
            </li>

        </ul>
    </div>
    <div class="col pb-1" style="overflow:auto;" [ngStyle]="{'max-height': maxHeight + 'px'}">
        <h6 class="mb-3">Tag asignados</h6>
        <ul (dndDrop)="onDrop($event,2)" (dndDrop)="onDropTagsSelected($event)"
            class="dndList list-group gap-1 flex-grow-1 bg-light rounded-1 shadow-sm" dndDropzone>
            <li *ngFor="let item of tagsSelected" [dndDraggable]="item" (dndStart)="onDragStart($event,2)"
                class="list-group-item border rounded-1 bg-white">
                <span><b><i class="fa-solid fa-tag me-1 text-success"></i>{{ item?.tag | uppercase }} </b></span>
                <small>({{ item?.code }})</small>
                <br>
                <span class="text-primary"><i class="fa-solid fa-map-location-dot"></i></span><span> {{item?.location || "Sin especificar"}}</span>
                
            </li>
            <li *ngIf="tagsSelected?.length==0">
                <small class="text-warning">
                    Sin tag agregados
                </small>
            </li>
        </ul>
    </div>
</div>